import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";

import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import RailwayDivision from "./pages/Masters/railwaybase/RailwayDivision";
import CoachType from "./pages/Masters/coachtype/CoachType";
import RepairType from "./pages/Masters/repairtype/RepairTypeMaster";
import CoachMakeMaster from "./pages/Masters/coachmake/CoachMakeMaster";
import ShopMaster from "./pages/Masters/shop/ShopMaster";
import CoachHistory from "./pages/History/CoachHistory/CoachHistory";
import CoachMaster from "./pages/Masters/coach/CoachMaster";
import YardEntry from "./pages/Entry/YardEntry";
// import ShopEntry from "./pages/Entry/ShopEntry";
import LiftEntry from "./pages/Entry/Lifting/LiftingList";
import ShellEntry from "./pages/Entry/Shell/ShellActivities";
import InspectionEntry from "./pages/Entry/Inspection/Inspection";
import Pdc from "./pages/Entry/PDC/Pdc";
import TechnicalReport from "./pages/Entry/TechnicalShell/TechnicalShell";
import TechnicalShell from "./pages/Entry/TechnicalShell/TechnicalShell";
import CoachHistoryAll from "./pages/History/CoachHistory/CoachHistorySearch";
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected */}
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/Railway" element={<RailwayDivision />} />

              <Route path="/division" element={<RailwayDivision />} />
              <Route path="/coachtype" element={<CoachType />} />
              <Route path="/repairtype" element={<RepairType />} />
              <Route path="/make" element={<CoachMakeMaster />} />
              <Route path="/shop" element={<ShopMaster />} />
              <Route path="/coach-history" element={<CoachHistory />} />
               <Route path="/coach-all-history" element={<CoachHistoryAll />} />

              <Route path="/coach-master" element={<CoachMaster />} />

              <Route path="/yard" element={<YardEntry />} />
              {/* <Route path="/shopentry" element={<ShopEntry />} /> */}
              <Route path="/lift" element={<LiftEntry />} />
              <Route path="/shell" element={<ShellEntry />} />
              <Route path="/inspection" element={<InspectionEntry />} />
              <Route path="/pdc" element={<Pdc />} />
              <Route path="/technical-clearance" element={<TechnicalShell />} />
            </Route>
          </Route>

          {/* Default */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
